import { Loader2 } from "lucide-react";

interface RecordingWaveProps {
  isTranscribing?: boolean;
  className?: string;
}

const BARS = [
  { delay: "0ms",   height: 28 },
  { delay: "100ms", height: 40 },
  { delay: "200ms", height: 20 },
  { delay: "50ms",  height: 48 },
  { delay: "150ms", height: 32 },
  { delay: "250ms", height: 44 },
  { delay: "75ms",  height: 24 },
  { delay: "175ms", height: 36 },
  { delay: "225ms", height: 48 },
  { delay: "125ms", height: 28 },
  { delay: "25ms",  height: 40 },
  { delay: "275ms", height: 20 },
  { delay: "325ms", height: 36 },
];

export default function RecordingWave({
  isTranscribing = false,
  className = "",
}: RecordingWaveProps) {
  if (isTranscribing) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-3 rounded-xl bg-secondary/30 ${className}`}
        role="status"
        aria-label="Transcription en cours"
      >
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
        <p className="text-sm text-muted-foreground font-medium">
          Transcription en cours…
        </p>
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 rounded-xl bg-destructive/5 border border-destructive/20 ${className}`}
      role="status"
      aria-label="Enregistrement en cours"
    >
      <div className="flex items-end justify-center gap-1 h-14">
        {BARS.map((bar, i) => (
          <span
            key={i}
            className="w-[5px] rounded-full bg-destructive origin-bottom"
            style={{
              height: `${bar.height}px`,
              animation: `recordWave 700ms ${bar.delay} ease-in-out infinite alternate`,
            }}
          />
        ))}
      </div>
      <p className="flex items-center gap-2 text-sm font-medium text-destructive">
        <span className="w-2 h-2 rounded-full bg-destructive animate-pulse shrink-0" />
        Enregistrement en cours…
      </p>
    </div>
  );
}
